'use strict';

const BundleRepository = require('./repository/BundleRepository');

module.exports = {
    'events': {
        'before:menu:more-parameters:ready': [
            {
                'callback': function(promises) {
                    promises.push(BundleRepository.findAll());
                },
            },
        ],
        'menu:more-parameters:ready': [
            {
                'callback': function(items) {
                    if (BundleRepository.bundles.length) {
                        items.push({'name': 'bundle_management'});
                    }
                },
            },
        ],
        'menu:more-parameters:bundle_management:click': [
            {'callback': require('./index').onMenuClick},
        ],
        'on:bundle:click': [
            {'callback': require('./index').onBundleClick},
        ],
    },
};
